<template lang="pug">
.personComponent(
  :class="personClasses"
)
  ui-avatar.avatarPerson(
    :url="urlPerson"
    :size="size"
  )
  span {{ firstName }}
</template>

<script>
export default {
  props: {
    urlPerson: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 40
    },
    firstName: {
      type: String,
      default: ''
    },
    isParent: Boolean,
    isDisabled: Boolean,
    isSelected: Boolean
  },
  computed: {
    personClasses () {
      return [
        { _selected: this.isSelected },
        { _disabled: this.isDisabled },
        { _parent: this.isParent }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
.personComponent
  display: flex
  align-items: center
  padding: $u 1.5*$u
  margin: 0.5*$u 0
  border-radius: 2*$u
  cursor: pointer
  @include font('t18-regular')

  &._selected
    background-color: $cElements
    color: $cDarkBlue

  &:hover::not(._disabled)
    color: $cLightBlue

  .avatarPerson
    margin-right: 2.5*$u

  &._parent
    @include font('m-t20-demibold')
    > .avatarPerson
      display: none

  &._disabled
    cursor: default

  @media (min-width: $mobileWidth) and (max-width: $padWidth)
    height: 16*$u
</style>
